module.exports = __webpack_public_path__ + "static/img/wxb.753bdea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxb.jpg
// module id = FPia
// module chunks = 1